import { createFileRoute } from "@tanstack/react-router";
import { TestesSistemaPage } from "@/paginas/testar-sistema";

export const Route = createFileRoute("/_authenticated/testar-sistema")({
  head: () => ({
    meta: [
      { title: "Testar sistema — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Central de testes do sistema: envio de notificações push e mensagens automáticas de verificação.",
      },
      { property: "og:title", content: "Testar sistema — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Central de testes do sistema: envio de notificações push e mensagens automáticas de verificação.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: TestesSistemaPage,
});
